export default __webpack_public_path__ + "static/media/freccia-sx.09b08b01.svg";